export default {
    selfInfoApi: {
      //基础配置
      selfInfo: {
            getSelfInfo: 'api/screen/selfInfo/getSelfInfo',
            saveOrUpdateSelfInfo: 'api/screen/selfInfo/saveOrUpdateSelfInfo',
        }

    }
}
